module.exports = __webpack_public_path__ + "img/app-splash.612ff57d.svg";